/* ── FLASHBACK THEME JS ── */

const swColors = ['#F5C518','#F0EDE6','#1a1a1a','#2AB5A0','#C0392B','#9B9EA5','linear-gradient(135deg,#e8e8e8,#f5f5f5)'];
const swNames  = ['Classic Yellow — 1984 Retro Stripes','Geometric White — Bauhaus','Space Black — Cosmic','Teal Art — Portrait','Bold Red — Statement','Synthwave Grey — 80s Night','Transparent — See-Through'];

let selectedColor  = 'Yellow';
let selectedBundle = 'Standart';

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.sw').forEach((sw, i) => {
    sw.style.background = swColors[i] || '#ccc';
  });
  updateVariant();
});

const heroSrcs = [];
document.querySelectorAll('.prod-img').forEach((img) => heroSrcs.push(img.src));

function heroCol(el, i) {
  document.querySelectorAll('.hdot').forEach(x => x.classList.remove('active'));
  el.classList.add('active');
  const heroImg = document.getElementById('heroImg');
  if (heroImg && heroSrcs[i]) heroImg.src = heroSrcs[i];
}

let currentImgIdx = 0;

function pickSw(el) {
  document.querySelectorAll('.sw').forEach(s => s.classList.remove('active'));
  el.classList.add('active');
  const i = parseInt(el.dataset.i);
  selectedColor = el.dataset.value;
  currentImgIdx = 0;
  showImg(i, 0);
  const label = document.getElementById('swLabel');
  if (label) label.textContent = '✦ ' + (swNames[i] || selectedColor + ' — 1984 Edition');
  updateVariant();
}

function showImg(colorIdx, imgIdx) {
  const allImgs = document.querySelectorAll('.prod-img');
  const target = colorIdx * 3 + imgIdx;
  allImgs.forEach((p, idx) => p.classList.toggle('active', idx === target));
  updateDots(imgIdx);
}

function changeImg(dir) {
  const colorIdx = parseInt(document.querySelector('.sw.active')?.dataset.i || 0);
  currentImgIdx = (currentImgIdx + dir + 3) % 3;
  showImg(colorIdx, currentImgIdx);
}

function updateDots(active) {
  document.querySelectorAll('.img-dot').forEach((d, i) => d.classList.toggle('active', i === active));
}

function pickBundle(el) {
  document.querySelectorAll('.bundle').forEach(b => b.classList.remove('active'));
  el.classList.add('active');
  selectedBundle = el.dataset.bundle;
  updateVariant();
}

function updateVariant() {
  const variants = window.productVariants || [];
  const match = variants.find(v => v.color === selectedColor && v.bundle === selectedBundle);
  if (!match) return;

  const price = '$' + Math.round(match.price / 100);
  const variantInput = document.getElementById('variantId');
  if (variantInput) variantInput.value = match.id;

  const buyPrice = document.getElementById('buyPrice');
  const stickyP  = document.getElementById('stickyPrice');
  if (buyPrice) buyPrice.textContent = price;
  if (stickyP) stickyP.textContent = price.replace('$','');
}

window.addEventListener('scroll', () => {
  const bar = document.getElementById('stickyBar');
  if (bar) bar.classList.toggle('on', window.scrollY > 500);
});

const stickyBtn = document.getElementById('stickyAddBtn');
if (stickyBtn) stickyBtn.addEventListener('click', () => {
  document.getElementById('product')?.scrollIntoView({ behavior: 'smooth' });
});

let exitShown = false;
document.addEventListener('mouseleave', e => {
  if (e.clientY < 0 && !exitShown) {
    exitShown = true;
    document.getElementById('exitOverlay')?.classList.add('show');
  }
});

const SYS = `You are a warm, friendly assistant for FLASHBACK, a retro 1984 keychain camera store. Keep answers to 2-3 sentences. Guide toward purchase. Camera: $39 Basic, $49 Standard (+32GB card), $62 Premium (+OTG reader). 7 colors. 1080P, 130° lens, USB-C, 1-3h battery, free shipping, 30-day returns.`;
let chatHistory = [];

async function askAI(q) {
  document.getElementById('chatSugs').style.display = 'none';
  addMsg(q, 'user');
  chatHistory.push({ role: 'user', content: q });
  const dot = addMsg('···', 'bot', true);
  try {
    const r = await fetch('https://api.anthropic.com/v1/messages', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ model: 'claude-sonnet-4-20250514', max_tokens: 150, system: SYS, messages: chatHistory })
    });
    const d = await r.json();
    const reply = d.content?.[0]?.text || "Check our FAQ below! 😊";
    dot.remove();
    addMsg(reply, 'bot');
    chatHistory.push({ role: 'assistant', content: reply });
    if (chatHistory.length > 10) chatHistory = chatHistory.slice(-10);
  } catch(e) {
    dot.remove();
    addMsg("Check our FAQ below for answers! 😊", 'bot');
  }
}

function sendAI() {
  const inp = document.getElementById('chatInp');
  const q = inp.value.trim();
  if (!q) return;
  inp.value = '';
  askAI(q);
}

function addMsg(t, type, isTyping = false) {
  const msgs = document.getElementById('chatMsgs');
  if (!msgs) return null;
  const d = document.createElement('div');
  d.className = 'chat-m ' + type;
  d.textContent = t;
  if (isTyping) d.style.opacity = '0.5';
  msgs.appendChild(d);
  msgs.scrollTop = msgs.scrollHeight;
  return d;
}
/* ── DUAL DEAL POPUP ── */
const dualState = {
  cam1: { bundle: 'Standart', price: 49, color: 'Yellow' },
  cam2: { bundle: 'Standart', price: 49, color: 'Yellow' }
};

function openDualPopup() {
  buildDualSwatches();
  updateDualPrices();
  document.getElementById('dualOverlay').classList.add('show');
  document.body.style.overflow = 'hidden';
}

function closeDualPopup() {
  document.getElementById('dualOverlay').classList.remove('show');
  document.body.style.overflow = '';
}

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('dualOverlay')?.addEventListener('click', function(e) {
    if (e.target === this) closeDualPopup();
  });
});

function buildDualSwatches() {
  [1, 2].forEach(camNum => {
    const container = document.getElementById('dual' + camNum + 'Swatches');
    if (!container || container.children.length > 0) return;
    swColors.forEach((col, i) => {
      const sw = document.createElement('div');
      sw.className = 'dual-sw' + (i === 0 ? ' active' : '');
      sw.style.background = col;
      sw.dataset.i = i;
      sw.dataset.cam = camNum;
      sw.onclick = function() { pickDualSwatch(this); };
      container.appendChild(sw);
    });
  });
}

function pickDualSwatch(el) {
  const camNum = el.dataset.cam;
  const cam = 'cam' + camNum;
  document.querySelectorAll('#dual' + camNum + 'Swatches .dual-sw').forEach(s => s.classList.remove('active'));
  el.classList.add('active');
  const i = parseInt(el.dataset.i);
  const colorMap = ['Yellow','White','Black','Cyan','Red','Grey','Transparent'];
dualState[cam].color = colorMap[i];
  document.getElementById('dual' + camNum + 'SwLabel').textContent = '✦ ' + swNames[i];
  updateDualPrices();
}

function pickDualBundle(el) {
  const cam = 'cam' + el.dataset.cam;
  el.closest('.dual-bundle-row').querySelectorAll('.dual-bundle-btn').forEach(b => b.classList.remove('active'));
  el.classList.add('active');
  dualState[cam].bundle = el.dataset.bundle;
  dualState[cam].price = parseInt(el.dataset.price);
  updateDualPrices();
}

function updateDualPrices() {
  const p1 = dualState.cam1.price;
  const p2 = dualState.cam2.price;
  const higher = Math.max(p1, p2);
  const lower = Math.min(p1, p2);
  const discounted = Math.round(lower * 0.6);
  const total = higher + discounted;
  const save = lower - discounted;

  if (p1 <= p2) {
    // מצלמה 1 זולה יותר — ההנחה עליה
    document.getElementById('dual1Price').innerHTML = '<span style="text-decoration:line-through;color:var(--gray);font-size:16px">$' + p1 + '</span> <span style="color:var(--orange)">$' + discounted + '</span>';
    document.getElementById('dual2OldPrice').style.display = 'none';
    document.getElementById('dual2Price').textContent = '$' + p2;
  } else {
    // מצלמה 2 זולה יותר — ההנחה עליה
    document.getElementById('dual1Price').textContent = '$' + p1;
    document.getElementById('dual2OldPrice').style.display = 'inline';
    document.getElementById('dual2OldPrice').textContent = '$' + p2;
    document.getElementById('dual2Price').textContent = '$' + discounted;
  }

  document.getElementById('dualTotal').textContent = '$' + total;
  document.getElementById('dualBtnPrice').textContent = '$' + total;
  document.getElementById('dualSaveTag').textContent = 'You save $' + save + '!';
}

async function addDualToCart() {
  const variants = window.productVariants || [];
  const v1 = variants.find(v => v.color === dualState.cam1.color && v.bundle === dualState.cam1.bundle);
  const v2 = variants.find(v => v.color === dualState.cam2.color && v.bundle === dualState.cam2.bundle);
  if (!v1 || !v2) { alert('Could not find variants. Please try again.'); return; }
  const btn = document.getElementById('dualAddBtn');
  btn.textContent = 'Adding...';
  try {
    const items = v1.id === v2.id ? [{ id: v1.id, quantity: 2 }] : [{ id: v1.id, quantity: 1 }, { id: v2.id, quantity: 1 }];
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    window.location.href = '/cart';
  } catch(e) {
    btn.textContent = 'Error — Try Again';
  }
}